<!--<div [ngStyle]="{width: size + 'px', height: size + 'px'}" class="db-loading-spinner" [ngClass]="{'db-loading-spinner_centered': centered}">
  <div class="db-loading-spinner__double-bounce"></div>
  <div class="db-loading-spinner__double-bounce"></div>
</div>-->

<div class="gooey">
  <span class="dot"></span>
  <div class="dots">
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>
